<script setup lang="ts">
import ConfirmDialog from "@/components/common/ConfirmDialog/ConfirmDialog.vue";
import CoreButton from "@/components/common/CoreButton/CoreButton.vue";
import { useI18n } from "vue-i18n";

export interface Props {
  visible: boolean;
  total: number;
  loading: boolean;
}

const { t } = useI18n();

const emit = defineEmits<{
  (e: "close"): void;
  (e: "submit"): void;
}>();

withDefaults(defineProps<Props>(), {
  loading: false,
  visible: false,
});
</script>

<template>
  <ConfirmDialog
    :title="t('visitors.timeline.confirm.anonymizeVisits', total)"
    :visible="visible"
    @close="emit('close')"
    @before-close="(done) => done()"
  >
    <p>{{ t("visitors.timeline.confirm.disclaimer") }}</p>
    <template #actions>
      <CoreButton
        type="info"
        plain
        :loading="loading"
        @click="emit('close')"
        >{{ t("buttons.cancel") }}
      </CoreButton>

      <CoreButton
        type="primary"
        :loading="loading"
        @click="emit('submit')"
        >{{ t("buttons.anonymizeVisits") }}
      </CoreButton>
    </template>
  </ConfirmDialog>
</template>
